module.exports = __webpack_public_path__ + "static/media/shops.48b65645.png";